import React, { Component } from 'react'
import PropTypes from 'prop-types'
import styles from './modal.styl'

export default class ModalCTA extends Component {
  static propTypes = {
    children: PropTypes.any.isRequired,
    relative: PropTypes.bool,
  }

  render() {
    const { relative } = this.props

    return (
      <div className={[styles.cta, relative ? styles.ctaRelative : ''].join(' ')}>
        <div className={styles.ctaContent}>
          {this.props.children}
        </div>
      </div>
    )
  }
}
